@if (actions['Assign Staff']) {
  <LOSx-group-assign-staff></LOSx-group-assign-staff>
}
@if (actions['Close']) {
  <LOSx-close-group></LOSx-close-group>
}
@if (actions['Activate']) {
  <LOSx-activate-group></LOSx-activate-group>
}
@if (actions['Attach Meeting']) {
  <LOSx-attach-group-meeting></LOSx-attach-group-meeting>
}
@if (actions['Attendance']) {
  <LOSx-group-attendance></LOSx-group-attendance>
}
@if (actions['Manage Members']) {
  <LOSx-manage-group-members></LOSx-manage-group-members>
}
@if (actions['Edit Meeting']) {
  <LOSx-edit-group-meeting></LOSx-edit-group-meeting>
}
@if (actions['Edit Meeting Schedule']) {
  <LOSx-edit-group-meeting-schedule></LOSx-edit-group-meeting-schedule>
}
@if (actions['Transfer Clients']) {
  <LOSx-group-transfer-clients></LOSx-group-transfer-clients>
}
